import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import BASE_URL from '../config/config';
import { FiHeadphones, FiClock, FiCode, FiPenTool, FiTrendingUp, FiShare2, FiMessageCircle, FiCheckCircle } from 'react-icons/fi';

const Inicio = () => {
  const [soporteDisponible, setSoporteDisponible] = useState(false);
  const [horario, setHorario] = useState(null); // objeto: { hora_inicio, hora_cierre, hora_cierre_viernes }

  const token = localStorage.getItem("AuthToken");
  const logged = !!token;
  const navigate = useNavigate();

  const handleCreateTicket = (department) => {
    window.scrollTo(0, 0);
    if (logged) {
      navigate('/nuevo-ticket', { state: { department } });
    } else {
      navigate('/iniciar-sesion');
    }
  };

  // Obtener horario desde ajustes
  useEffect(() => {
    const fetchHorario = async () => {
      try {
        const resp = await axios.get(`${BASE_URL}/ajustes/horario`);
        const valor = resp?.data?.ajuste?.valor;
        if (valor) setHorario(valor);
      } catch {
        setHorario(null);
      }
    };
    fetchHorario();
  }, []);

  const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

  // Calcular disponibilidad cuando el horario esté cargado
  useEffect(() => {
    if (!horario) return;

    const ahora = new Date();
    const dia = ahora.getDay();
    const horaDecimal = ahora.getHours() + ahora.getMinutes() / 60;

    const horaInicio = horario.hora_inicio ?? 8;
    const horaCierre = horario.hora_cierre ?? 16;
    const horaCierreViernes = horario.hora_cierre_viernes ?? 15;

    const esLaborable = dia >= 1 && dia <= 5;
    const cierreHoy = dia === 5 ? horaCierreViernes : horaCierre;

    setSoporteDisponible(esLaborable && horaDecimal >= horaInicio && horaDecimal < cierreHoy);
  }, [horario]);

  // Formatear el horario de hoy para mostrar en pantalla
  let textoHorario = 'Cargando...';
  if (horario) {
    const dia = new Date().getDay();
    const horaInicio = horario.hora_inicio ?? 8;
    const horaCierre = horario.hora_cierre ?? 16;
    const horaCierreViernes = horario.hora_cierre_viernes ?? 15;
    const esLaborable = dia >= 1 && dia <= 5;
    const cierreHoy = dia === 5 ? horaCierreViernes : horaCierre;

    textoHorario = esLaborable
      ? <>Hoy ({diasSemana[dia]}): {horaInicio}:00–{cierreHoy}:00</>
      : <>Hoy ({diasSemana[dia]}): Cerrado</>;
  }

  return (
    <main className='inicio'>
      <div className="bg-intro">
        <div className="bg-intro-blob bg-intro-blob-1"></div>
        <div className='site-width'>
          <div className='intro'>
            <div className="intro-text">
              <h1>El soporte técnico más cercano <br/>para <span>nuestros clientes</span></h1>
              <p>Haznos saber tu causa. Crea un ticket y sigue el progreso desde esta misma web.</p>
            </div>
            <div className="intro-info">
              <div className="support-time">
                <span className="intro-icon"><FiHeadphones /></span>
                <div className="support-text">
                  <p>Soporte Técnico</p>
                  <p className='disponible'><span className='pulse-dot'></span>Activo</p>
                </div>
              </div>
              <div className="office-time">
                <span className="intro-icon"><FiClock /></span>
                <div className="office-text">
                  <p>Horario de oficina</p>
                  <p>{textoHorario}</p>
                </div>
              </div>
            </div>
          </div>

          {/* departamentos */}
          <div className="departments">
            <div className="department">
              <span className="department-icon"><FiCode /></span>
              <h2>Dpto. de Desarrollo</h2>
              <p>Si tu cuestión tiene que ver con desarrollo web.</p>
              <button
                className='token-ticket'
                onClick={() => handleCreateTicket('desarrollo')}
              >
                {logged ? 'Crear ticket' : 'Inicia sesión para crear un ticket'}
              </button>
            </div>
            <div className="department">
              <span className="department-icon"><FiPenTool /></span>
              <h2>Dpto. de Diseño</h2>
              <p>Si tu cuestión tiene que ver con diseño gráfico.</p>
              <button
                className='token-ticket'
                onClick={() => handleCreateTicket('diseno')}
              >
                {logged ? 'Crear ticket' : 'Inicia sesión para crear un ticket'}
              </button>
            </div>
            <div className="department">
              <span className="department-icon"><FiTrendingUp /></span>
              <h2>Dpto. de Marketing</h2>
              <p>Si tu cuestión tiene que ver con marketing digital.</p>
              <button
                className='token-ticket'
                onClick={() => handleCreateTicket('marketing')}
              >
                {logged ? 'Crear ticket' : 'Inicia sesión para crear un ticket'}
              </button>

            </div>
            <div className="department">
              <span className="department-icon"><FiShare2 /></span>
              <h2>Dpto. de Redes Sociales</h2>
              <p>Si tu cuestión tiene que ver con redes sociales.</p>
              <button
                className='token-ticket'
                onClick={() => handleCreateTicket('redes_sociales')}
              >
                {logged ? 'Crear ticket' : 'Inicia sesión para crear un ticket'}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* comunidad */}
      <div className='bg-comunidad'>
        <div className="site-width">
          <div className="comunidad">
            <div className="comunidad-img-wrapper">
              <img src="images/imagen-comunidad.svg" alt="Imagen Comunidad" />
            </div>
            <div className='texto-comunidad'>
              <span className="comunidad-badge">Nuestra filosofía</span>
              <h2>Juntos construimos <span>comunidad</span></h2>
              <p className="comunidad-lead">Olvida los correos perdidos en la bandeja de entrada y las conversaciones interminables. Centralizamos todo tu soporte en un solo lugar, claro y siempre a mano.</p>
              <ul className="comunidad-features">
                <li>
                  <span className="comunidad-feature-icon"><FiMessageCircle /></span>
                  Conversaciones centralizadas, sin cadenas de correo
                </li>
                <li>
                  <span className="comunidad-feature-icon"><FiClock /></span>
                  Seguimiento del progreso en tiempo real
                </li>
                <li>
                  <span className="comunidad-feature-icon"><FiHeadphones /></span>
                  Atención cercana y personalizada en cada ticket
                </li>
                <li>
                  <span className="comunidad-feature-icon"><FiCheckCircle /></span>
                  Todo el historial de tu proyecto, siempre disponible
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Inicio;
